/**
 * Utility for detecting and configuring browser mode
 */

// Treat as browser ONLY if no Electron-related globals are present.
// With contextIsolation enabled, the safest indicator we expose is window.electronAPI (set in preload).
export const isBrowserMode = () => {
  return !window.electronAPI && !window.process?.versions?.electron && !window.electron;
};

// Check if we're in stable browser mode (prevents refresh issues)
export const isStableBrowserMode = () => {
  return isBrowserMode() && 
    (window.location.pathname.includes('browser-stable') || 
     localStorage.getItem('browser_mode') === 'true' ||
     sessionStorage.getItem('disable_auto_refresh') === 'true');
};

// Prevent automatic refresh cycles
export const preventRefreshCycles = () => {
  if (isBrowserMode()) {
    // Store in session to prevent refresh loops
    sessionStorage.setItem('disable_auto_refresh', 'true');
    
    // Disable hot module reload if in browser mode
    if (module.hot && isStableBrowserMode()) {
      console.log('🔒 Disabling hot module reload for stability');
      module.hot.decline();
    }
  }
};

// Get API base URL based on environment
export const getApiBaseUrl = () => {
  // Use environment variable if set (with react-scripts)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // If in browser mode with Cloudflare deployment, use /functions
  if (isBrowserMode()) {
    return '/functions';
  }
  
  // Default for Electron mode
  return '/api';
};

// Log mode at startup
export const logAppMode = () => {
  if (isStableBrowserMode()) {
    console.log('%c🌐 Qawaem - Running in Stable Browser Mode (Auto-refresh disabled)', 
      'font-size: 14px; font-weight: bold; color: #4287f5;');
    preventRefreshCycles();
  } else if (isBrowserMode()) {
    console.log('%c🌐 Qawaem - Running in Browser Mode', 
      'font-size: 14px; font-weight: bold; color: #4287f5;');
  } else {
    console.log('%c🖥️ Qawaem - Running in Electron Mode', 
      'font-size: 14px; font-weight: bold; color: #42f57b;');
  }
};

export default {
  isBrowserMode,
  getApiBaseUrl,
  logAppMode
};
